/**
 * Homepage image paths. All components that need these images import from here.
 *
 * Large originals in /public/images are kept for reference; delivery uses resized assets.
 */
const homeImages = {
  banner: "/images/banner-poster-1280.jpg",
  bannerPosterLarge: "/images/banner-poster-1920.jpg",
  aboutPrimary: "/images/about-primary-1200.jpeg",
  aboutPrimarySrcSet: "/images/about-primary-1200.jpeg 1200w",
  aboutSecondary:
    "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,w_1200/v1726497991/werkix/talent/mada_yyewbl.jpg",
  whyUsMain:
    "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,w_1400/v1773829249/werkix/team/less%20noise/dbecdc7fcc1c5d26869e0167a0894a86_ltxv8d.jpg",
  whyUsGrid: [
    "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,w_800/v1718824838/werkix/home/peter_uqgjsw.png",
    "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,w_800/v1773829178/werkix/team/less%20noise/928366910c00d431fd74c9726772731f_i666de.jpg",
    "/images/8ee098e61c342695e91ee4cc2a0e3619.jpeg",
  ],
  footerBg: "/images/banner-poster-1280.jpg",
  aboutHeaderBg:
    "https://res.cloudinary.com/dhbe6wtod/image/upload/f_auto,q_auto:good,w_1600/v1719420028/werkix/about-main/about-header-bg_vs8qau.jpg",
  careersHeroBg: "/images/aeea3b9ecc61fcdeef2b207cd76ba0ae.jpeg",
};

export default homeImages;
